'use client'
import React, {SetStateAction} from 'react';
import {faCirclePlus, faCircleMinus} from '@fortawesome/free-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {IconProp} from '@fortawesome/fontawesome-svg-core';

export default function ExpandFieldBtn({
                                           title = null,
                                           open,
                                           setOpen,
                                       }: {
    title?: string;
    open: boolean;
    setOpen: React.Dispatch<SetStateAction<boolean>>;
}) {

    const onClick = () => {
        setOpen(!open);
    }

    return (

        <button className="ms-4 hover:text-blue-600 rounded-xl px-2 py-1 flex items-center" type="button"
                onClick={onClick}><span
            className="me-3"><strong>{title}</strong></span><i
            className="mio">{open ? 'keyboard_arrow_up' : 'keyboard_arrow_down'}</i></button>
    )
        ;
}
